import React from 'react';

// Whether Studio is editing a dashboard or a report: block settings saved on
// the gadget (Studio.GadgetSettings) mean different things on each
const StudioContentTypeContext =
  React.createContext<Studio.ContentType>('dashboard');

export default StudioContentTypeContext;
